import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/risk360-backoffice-actions/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.RISK360_BACKOFFICE_ACTIONS, permission: Permission.UPDATE }) ||
      !!context.userPermissions.isBackOfficeAvailable;
    context.validatePermissions({ isAllowed, preload });
  },
});
